import { useContext } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { Redirect, useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import ValidationInput from 'src/components/input/ValidationTextInput';
import * as Yup from 'yup';
import { useAPI } from '../services/api';
import AuthContext from '../contexts/auth-context';
import ToastContext from '../contexts/toast-context';

const stringValidation = ({ min = 2, max = 255 } = {}) =>
  Yup.string().min(min, 'Too Short!').max(max, 'Too Long!').required('Required');

const loginSchema = Yup.object().shape({
  username: stringValidation(),
  password: stringValidation(),
});

const LoginPage = () => {
  let api = useAPI();
  const history = useHistory();
  const auth = useContext(AuthContext);
  const { handleError, success } = useContext(ToastContext);
  let redirectPath = new URLSearchParams(history.location.search).get('redirect') ?? '/';

  const login = async (values) => {
    try {
      let response = await api.post('/users/login', values);
      auth.login(response.data.token);
      history.replace(redirectPath);
      success('Logged in!');
    } catch (e) {
      handleError(e);
    }
  };

  const initialValues = {
    username: '',
    password: '',
  };

  if (auth.isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <>
      <h1 className="mt-4 text-center justify-content-center w-100">Login</h1>
      <Row className="mt-5 justify-content-center">
        <Col md={8} style={{ maxWidth: 600 }}>
          <Card className="p-3">
            <Formik onSubmit={login} initialValues={initialValues} validationSchema={loginSchema}>
              <Form>
                <ValidationInput name="username" autoComplete="username" />
                <ValidationInput name="password" type="password" autoComplete="current-password" />
                <Button variant="primary" type="submit" data-cy="login">
                  Login
                </Button>
              </Form>
            </Formik>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default LoginPage;
